import { render, staticRenderFns } from "./WorkBookQuestionsList.vue?vue&type=template&id=0b72fdf8&scoped=true&"
import script from "./WorkBookQuestionsList.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsList.vue?vue&type=style&index=0&id=0b72fdf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72fdf8",
  null
  
)

export default component.exports